import { render, staticRenderFns } from "./SendDocumentList.vue?vue&type=template&id=8f164588&scoped=true&lang=pug"
import script from "./SendDocumentList.vue?vue&type=script&lang=ts"
export * from "./SendDocumentList.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentList.vue?vue&type=style&index=0&id=8f164588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f164588",
  null
  
)

export default component.exports